module.exports = __webpack_public_path__ + "img/calendar-today-black.673199ad.svg";